<template>
  <router-link :to='{ name: "culture", params: { idExploitation : idExploitation, idCulture: culture.id_culture }}' class='item-bloc'>
    <header>
      <span>{{ culture.nom }}</span>
      <button v-can:edit-exploitation class='action-icon duplicate-btn btn-white mr-5' @click.prevent='duplicateBloc' title="Dupliquer la culture"/>
      <button v-can:edit-exploitation class='action-icon delete-btn btn-white' @click.prevent='deleteBloc' title="Supprimer la culture"/>
    </header>
    <div>
      <div class='subtitle'>Information</div>
      {{ 'type' | pluralize(nbSols) }} de sol, {{ 'stade' | pluralize(nbStades) }}

      <template v-if='culture.complement'>
        <div class='subtitle'>Complément d'information</div>
        {{ culture.complement | truncateChars(30) }}
      </template>

      <template v-if='culture.date_semis'>
        <div class='subtitle'>Date de semis</div>
        {{ culture.date_semis | formatDate }}
      </template>

      <template v-if='variete'>
        <div class='subtitle'>Variété / Groupe précocité</div>
        {{ variete.nom }}
      </template>

      <template v-if='culturePrecedente'>
        <div class='subtitle'>Culture précédente</div>
        {{ culturePrecedente.nom }}
      </template>

    </div>

  </router-link>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'BlocCulture',

  props: {
    idExploitation: {
      type: String,
      required: true
    },
    culture: {
      type: Object,
      required: true
    }
  },

  computed: {
    sols () {
      return this.$store.getters.getSolCultureById(this.culture.id_culture)
    },

    nbSols () {
      return this.sols.length
    },

    stades () {
      return this.$store.getters.getStadeCultureById(this.culture.id_culture)
    },

    nbStades () {
      return this.stades.length
    },

    variete () {
      return this.$store.getters['referentiel/getVarieteById'](this.culture.id_ref_variete)
    },

    culturePrecedente () {
      return this.$store.getters['referentiel/getCulturePrecedenteById'](this.culture.id_culture_precedente)
    }
  },

  methods: {
    ...mapActions('confirm', ['confirm']),
    deleteBloc () {
      this.confirm({
        title: 'Suppression culture',
        message: 'Êtes vous-sûr de vouloir supprimer cette culture ?',
        okText: 'Supprimer'
      })
        .then(confirmation => {
          if (confirmation) {
            this.$emit('remove', this.culture)
          }
        })
    },

    duplicateBloc () {
      this.$emit('duplicate', this.culture)
    }
  }

}
</script>
